export default __webpack_public_path__ + "static/new-window-before-63ce9c8b49c2eecc1efcf8ca015b0172.png";